/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Errors_Notfounddescription2Inputs */

const id_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil ini tidak tersedia atau belum diindeks.`)
};

const ms_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil ini tidak tersedia atau belum diindeks.`)
};

const da_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne profil er utilgængelig eller er ikke blevet indekseret endnu.`)
};

const de_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Profil ist nicht verfügbar oder wurde noch nicht indexiert.`)
};

const en_us2_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This profile is unavailable or has not been indexed yet.`)
};

const es_es2_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este perfil no está disponible o aún no ha sido indexado.`)
};

const es_mx2_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este perfil no está disponible o aún no ha sido indexado.`)
};

const fil_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang profile na ito ay hindi available o hindi pa na-index.`)
};

const fr_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce profil est indisponible ou n'a pas encore été indexé.`)
};

const it_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo profilo non è disponibile o non è stato ancora indicizzato.`)
};

const hu_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a profil nem elérhető, vagy még nem lett indexelve.`)
};

const nl_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit profiel is niet beschikbaar of is nog niet geïndexeerd.`)
};

const no_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne profilen er utilgjengelig eller har ikke blitt indeksert ennå.`)
};

const pl_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten profil jest niedostępny lub nie został jeszcze zindeksowany.`)
};

const pt_br2_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este perfil não está disponível ou ainda não foi indexado.`)
};

const pt_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este perfil está indisponível ou ainda não foi indexado.`)
};

const ro_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acest profil este indisponibil sau nu a fost încă indexat.`)
};

const fi_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä profiili ei ole käytettävissä tai sitä ei ole vielä indeksoitu.`)
};

const sv_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna profil är inte tillgänglig eller har inte indexerats än.`)
};

const vi_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ sơ này không khả dụng hoặc chưa được lập chỉ mục.`)
};

const tr_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu profil kullanılamıyor veya henüz dizine eklenmedi.`)
};

const cs_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento profil není k dispozici nebo ještě nebyl indexován.`)
};

const bg_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Този профил не е наличен или все още не е индексиран.`)
};

const ru_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот профиль недоступен или ещё не проиндексирован.`)
};

const uk_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей профіль недоступний або ще не був проіндексований.`)
};

const ar_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا الملف الشخصي غير متاح أو لم يتم فهرسته بعد.`)
};

const hi_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह प्रोफ़ाइल अनुपलब्ध है या अभी तक इंडेक्स नहीं की गई है।`)
};

const th_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรไฟล์นี้ไม่พร้อมใช้งานหรือยังไม่ได้ถูกจัดทำดัชนี`)
};

const ja_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプロフィールは利用できないか、まだインデックスされていません。`)
};

const zh_cn2_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此个人资料不可用或尚未被索引。`)
};

const zh_hant1_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此個人資料無法使用或尚未被索引。`)
};

const ko_profile_errors_notfounddescription2 = /** @type {(inputs: Profile_Errors_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 프로필을 사용할 수 없거나 아직 인덱싱되지 않았습니다.`)
};

/**
* | output |
* | --- |
* | "This profile is unavailable or has not been indexed yet." |
*
* @param {Profile_Errors_Notfounddescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_errors_notfounddescription2 = /** @type {((inputs?: Profile_Errors_Notfounddescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Errors_Notfounddescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_errors_notfounddescription2(inputs)
	if (locale === "ms") return ms_profile_errors_notfounddescription2(inputs)
	if (locale === "da") return da_profile_errors_notfounddescription2(inputs)
	if (locale === "de") return de_profile_errors_notfounddescription2(inputs)
	if (locale === "en-US") return en_us2_profile_errors_notfounddescription2(inputs)
	if (locale === "es-ES") return es_es2_profile_errors_notfounddescription2(inputs)
	if (locale === "es-MX") return es_mx2_profile_errors_notfounddescription2(inputs)
	if (locale === "fil") return fil_profile_errors_notfounddescription2(inputs)
	if (locale === "fr") return fr_profile_errors_notfounddescription2(inputs)
	if (locale === "it") return it_profile_errors_notfounddescription2(inputs)
	if (locale === "hu") return hu_profile_errors_notfounddescription2(inputs)
	if (locale === "nl") return nl_profile_errors_notfounddescription2(inputs)
	if (locale === "no") return no_profile_errors_notfounddescription2(inputs)
	if (locale === "pl") return pl_profile_errors_notfounddescription2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_errors_notfounddescription2(inputs)
	if (locale === "pt") return pt_profile_errors_notfounddescription2(inputs)
	if (locale === "ro") return ro_profile_errors_notfounddescription2(inputs)
	if (locale === "fi") return fi_profile_errors_notfounddescription2(inputs)
	if (locale === "sv") return sv_profile_errors_notfounddescription2(inputs)
	if (locale === "vi") return vi_profile_errors_notfounddescription2(inputs)
	if (locale === "tr") return tr_profile_errors_notfounddescription2(inputs)
	if (locale === "cs") return cs_profile_errors_notfounddescription2(inputs)
	if (locale === "bg") return bg_profile_errors_notfounddescription2(inputs)
	if (locale === "ru") return ru_profile_errors_notfounddescription2(inputs)
	if (locale === "uk") return uk_profile_errors_notfounddescription2(inputs)
	if (locale === "ar") return ar_profile_errors_notfounddescription2(inputs)
	if (locale === "hi") return hi_profile_errors_notfounddescription2(inputs)
	if (locale === "th") return th_profile_errors_notfounddescription2(inputs)
	if (locale === "ja") return ja_profile_errors_notfounddescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_errors_notfounddescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_errors_notfounddescription2(inputs)
	return ko_profile_errors_notfounddescription2(inputs)
});
export { profile_errors_notfounddescription2 as "profile.errors.notFoundDescription" }